import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CircleCheck } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
declare global {
  interface Window {
    Calendly?: {
      initPopupWidget: (options: {
        url: string;
      }) => void;
    };
  }
}
export default function WhoWeWorkWith() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const clientCharacteristics = [{
    id: 1,
    text: "Feel persistently low energy or burned out"
  }, {
    id: 2,
    text: "Are struggling with weight, metabolism, or body composition"
  }, {
    id: 3,
    text: "Have low libido, ED, or performance concerns"
  }, {
    id: 4,
    text: "Experience brain fog, low motivation, or poor focus"
  }, {
    id: 5,
    text: "Want proactive longevity and health optimization"
  }, {
    id: 6,
    text: "Value medical oversight and evidence-based care"
  }];
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);
  const handleCalendlyClick = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/mfloresdo/30min'
      });
    }
  };
  return <section className="bg-background py-8 sm:py-8 lg:py-8">
      <div className="container">
        <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6 text-center">
            Who We Work With
          </h2>
          
          <p className="text-base sm:text-lg text-muted-dark mb-8 leading-relaxed text-center">
            At Iron Peak Men's Health, we partner with men who are ready to take control of their health and well-being. IronPeak is a good fit for men who:
          </p>

          <ul className="space-y-4">
            {clientCharacteristics.map((characteristic, i) => <li key={characteristic.id} data-index={i} className={`flex items-start gap-3 transition-all duration-500 delay-${i * 100} ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-4 opacity-0"}`}>
                <CircleCheck className="size-6 text-primary shrink-0 mt-0.5" />
                <span className="text-base sm:text-lg text-foreground leading-relaxed">
                  {characteristic.text}
                </span>
              </li>)}
          </ul>

          <p className="text-base sm:text-lg text-foreground leading-relaxed text-center mt-8">
            If you're looking for shortcuts or miracle fixes, we may not be the right fit. If you want thoughtful, medical care designed around you, you likely are.
          </p>

          <div className="flex flex-col items-center mt-8">
            <Button onClick={handleCalendlyClick} className="inline-flex items-center justify-center rounded-sm bg-accent text-accent-foreground px-6 py-3 font-semibold hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
              Schedule a Consultation
            </Button>
            <p className="text-sm text-center text-muted-dark mt-3">
              Medical evaluation first. No pressure. Treatment only if appropriate.
            </p>
          </div>
        </div>
      </div>
    </section>;
}